import { render, staticRenderFns } from "./ServerGraphs.vue?vue&type=template&id=33e78e36&"
import script from "./ServerGraphs.vue?vue&type=script&lang=js&"
export * from "./ServerGraphs.vue?vue&type=script&lang=js&"
import style0 from "./ServerGraphs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33e78e36')) {
      api.createRecord('33e78e36', component.options)
    } else {
      api.reload('33e78e36', component.options)
    }
    module.hot.accept("./ServerGraphs.vue?vue&type=template&id=33e78e36&", function () {
      api.rerender('33e78e36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Common/ServerGraphs.vue"
export default component.exports